module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"default":"How Can I Help You?","paymentDialogHeader":"Payments"},"es":{"default":"¿Le puedo ayudar en algo?","paymentDialogHeader":"Pagos"}}')
  delete Component.options._Ctor
}
